import { useContext } from 'react'
import { bannerContext } from './bannerContext'

export const useBanner = () => {
  const { ...exposedFields } = useContext(bannerContext)

  return exposedFields
}
